import { SanityConfig } from '@/configs/sanity.config';
import { createClient } from '@sanity/client';

export const sanityClient = createClient({
	projectId:   SanityConfig.projectid,
	dataset:     SanityConfig.dataset,
	apiVersion:  SanityConfig.apiVersion,
	useCdn:      !SanityConfig.revalidateSecret,
	perspective: 'published',
	stega:       {
		studioUrl: SanityConfig.basePath,
		filter:    (props) => {
			return props.sourcePath.at(-1) === 'title' ? true : props.filterDefault(props);
		},
	},
});